import { OrderMeal } from '@/models';
import { AnalyticsEvent } from '../models';

export class BagClickEvent implements AnalyticsEvent {
  bagEventType: string;
  name = 'BagClickEvent';

  constructor(event: string, public readonly meals?: OrderMeal | OrderMeal[] | null, public readonly orderPath?: string) {
    this.bagEventType = event;
  }
}
